<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <Dialog
        :visible.sync="printDialog"
        header="Do you want to print this bill?"
        :style="{width: '35vw'}"
        :modal="true"
      >
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <Button class="p-button-raised p-button-rounded" @click="printBill" label="Yes"/>
            <Button class="p-button-raised p-button-danger" @click="closePrintDialog" label="No"/>
          </div>
        </div>
      </Dialog>
      <Dialog header="Latest Last Rate" :modal="true" :visible.sync="salesRateDetails"
              :style="{width: '60vw'}" :closable=true :contentStyle="{'overflow': 'scroll'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-12">
            <DataTable :value="latestSalesRateList" class="editable-cells-table">
              <Column header="Date" field="nepaliDate"/>
              <Column header="Bill No" field="billNo"/>
              <Column header="voucher" field="voucher"/>

              <Column header="Quantity" field="outQuantity"/>

              <Column header="Rate" field="price"/>

            </DataTable>
          </div>
        </div>
        <template #footer>
          <!-- <Button label="Save" class="p-button-raised p-button-rounded"/> -->
          <Button label="Cancel" @click="closeSalesRatesLatest"
                  class="p-button-raised p-button-danger"/>
        </template>
      </Dialog>
      <Dialog header="Varients Details"  :modal="true"
              :visible.sync="displayVarientsDialog"
              :closable=true :style="{width: '50vw'}" :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">


           <div class="p-field p-col-12 p-md-12">

          <DataTable :value="variantDetailslist" editMode="cell" class="editable-cells-table" ref="po">
          <Column field="propertyValue"  header="Name" filterMatchMode="contains">
    
              </Column>

                <Column header="Pur Qty" field="quantity">
            </Column>

              <Column header="Avl Qty" field="avlQuantity">
            </Column>

            <Column header="Sales Qty" field="salesQuantity">
              <template #editor="slotProps">
                <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                             :maxFracionDigits="4"/>
              </template>
            </Column>

          </DataTable>
           </div>


          <!-- <div class="p-field p-col-12 p-md-6">
            <label for="ccRate">CC/Rate</label>
            <InputNumber   id="ccRate" mode="decimal" onfocus="if (this.value === '0.00')
                              this.value = ''" v-model="ccRate"  :minFractionDigits="2" :maxFracionDigits="4" />
          </div> -->
          <!-- <div style="display:none" > {{findCcRate.toFixed(4)}}</div> -->
        </div>
        <!-- <template #footer>
          <Button class="p-button-raised p-button-rounded" @click.prevent="closeBasicBatchDetails" label="Save"/>
          <Button @click.prevent="closeBasicBatchDetails" class="p-button-raised p-button-danger"
                  label="Cancel"/>
        </template> -->

        <Button @click.prevent="closeBasicBatchDetails" style="float:right" class="p-button-raised p-button-danger"
                  label="Close"/>
      </Dialog>
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label>Date</label>
            <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" ref="tran" v-else class="nepali-calendar" id="purchaseSalesDate"
                       v-model="purchaseSalesDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="billNo">Invoice No</label>
            <InputText id="billNo" v-model="billNo" disabled/>
          </div>
          <!-- <label for="refno" class="col-sm-2 control-label" >Reference No</label>
            <div class="col-sm-2">
              <input type="text" class="form-control" id="refno"  v-model="referenceNumber" />
            </div> -->
          <div class="p-field p-col-12 p-md-2">
            <label for="paymentType">Sales Type</label>
            <select class="form-control" v-model="taxType">
              <option selected disabled value="">Select Sales Type</option>
              <option v-for="(tax,ind) in taxTypeList" :key="ind">{{ tax.name }}</option>
            </select>
          </div>
        </div>
        <!-- <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label for="loadFrom">Load From </label>
            <label class="radio-inline">
              <input type="radio" v-model="loadType" name="order" value="order"
                     @change="loadFrom(loadType)"/>Order</label>
            <label class="radio-inline">
              <input type="radio" v-model="loadType" name="challan" value="challan" @change="loadFrom(loadType)"/>Challan</label>
          </div>
          <div class="p-field p-col-12 p-md-2" v-if="loadFromOrder && !this.editing">
            <label for="OrderList" v-if="loadFromOrder && !this.editing"> Order List</label>
            <Dropdown
              v-model="orderId"
              :options="orderIdList"
              optionLabel="orderNo"
              :filter="true"
              @change="loadSalesOrderDataWithOrderNo(orderId.orderNo)"
              placeholder="Select Item"
            />
          </div>
          <div class="p-field p-col-12 p-md-2" v-if="loadFromChallan && !this.editing">
            <label for="ChallanList" v-if="loadFromChallan && !this.editing"> Challan List</label>
            <Dropdown
              v-model="challanId"
              :options="challanIdList"
              optionLabel="challanNo"
              :filter="true"
              @change="loadSalesOrderDataWithChallanNo(challanId.challanNo)"
              placeholder="Select Item"
            />
          </div>


        </div> -->
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <!-- <div class="p-field p-col-12 p-md-3">
            <label>Sale To</label>
            <Dropdown
              v-model="accountMaster"
              :options="supplierAndCustomerList"
              :filter="true"
              optionLabel="nameWithContact"
              placeholder="Select Account"
              :showClear="true"
              @change="getCreditLimitAmount"
            />
          </div>
          <customerDialog class="p-mt-6" v-tooltip.top="'Add Customer'"
                          @set_customer_master="set_customer_master"/>
          <div v-if="ifCash" class="p-field p-col-12 p-md-2">
            <label>Customer</label>
            <Dropdown
              v-model="customer"
              :options="customerAccountList"
              optionLabel="name"
              :filter="true"
              placeholder="Select customer"
              :showClear="true"
            />
          </div>
          <customerDialog v-if="ifCash" class="p-mt-6" v-tooltip.top="'Add Customer'"
                          @set_customer_master="set_customer_master"/> -->
          <div class="p-field p-col-12 p-md-2">
            <label for="warehouse">Store</label>
            <Dropdown
              v-if="!setWarehouseData"
              v-model="warehouse"
              :options="warehouseLists"
              :filter="true"
              optionLabel="name"
              placeholder="Select Warehouse"
              :showClear="true"
            />
            <Dropdown
              v-if="setWarehouseData"
              v-model="warehouse"
              :options="warehouseLists"
              :filter="true"
              optionLabel="name"
              placeholder="Select Warehouse"
              :disabled="true"
            />
            <!-- {{warehouse}} -->
          </div>
          <warehouseDialog class="p-mt-6" style="margin-right: -10em;" v-tooltip.top="'Add Warehouse'"
                           @set_data_warehouse="set_data_warehouse"/>

        </div>


        <div class="p-fluid p-formgrid p-grid p-mt-2" v-show="accountMaster.id > 0">
          <div class="p-field p-col-12 p-md-2" v-if="accountMaster.id > 0">
            <label for="panNo">Tax No: </label>
            <b class="p-ml-5">{{ accountMaster.panNo }}</b>
            <label for="panNo">Cur. Bal: </label>
            <b style="color:red;" v-if="accountMaster.closingBalance>0">
              {{ (accountMaster.closingBalance).toFixed(2) + 'Cr' }}
            </b>
            <b style="color:green;" v-else>
              {{ (accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr' }}
            </b>
          </div>
          <!-- <div class="p-field p-col-12 p-md-3">
            <label for="loadFromItem">Load Item From </label>
            <label class="radio-inline">
              <input type="radio" v-model="entryType" name="Items" value="Items" @change="loadFromItem(entryType)"/>Items</label>
            <label class="radio-inline">
              <input type="radio" v-model="entryType" name="Purchase" value="Purchase"
                     @change="loadFromItem(entryType)"/>Purchase</label>
          </div> -->
        </div>


        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label for="itm">Item<span style="color:red;">*</span></label>

            <AutoComplete v-model="item" v-if="!loadItemFromPurchase" filterMatchMode="contains"
                          :suggestions="filteredItems" @complete="searchItem($event)" filterType="contains"
                          field="name" ref="itm">
              <template #item="slotProps">
                <div style="font-size: 12px !important;">{{ slotProps.item.name }} - {{ slotProps.item.itemCode }}</div>
              </template>
            </AutoComplete>

            <AutoComplete v-model="item" v-else filterMatchMode='contains'
                          :suggestions="filterPurchase" @complete="searchPurchaseItem($event)"
                          field="itemToDisplayName" ref="itm">
            </AutoComplete>

          </div>
          <itemDialog class="p-mt-5" style="margin-right: -10em;" v-tooltip.top="'Add Item'"
                      @set_data_item="set_data_item"/>

          <div class="p-field p-col-12 p-md-2">
            <label for="qty">Sales Qty</label>
            <!-- <input type="text" class="form-control" id="qty" @keypress="isNumber(event)" v-model="quantity"/> -->
            <InputNumber id="minmaxfraction" v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div v-if="!item.multiUnit" class="p-field p-col-12 p-md-1">
            <label for="qty">Unit</label>
            <input type="text" class="form-control" v-model="item.unitName" disabled/>
          </div>
          <div v-if="item.multiUnit" class="p-field p-col-12 p-md-2">
            <label for="unit">Unit</label>
            <Dropdown
              v-model="alternateUnit"
              :options="item.itemMultiUnitDetailsDTOList"
              optionLabel="unitTo"
              :filter="true"
              placeholder="Select One"
              id="unit"
            />
          </div>
          <div v-if="item.multiUnit" class="p-field p-col-12 p-md-1">
            <label for="unit"></label>
            <Button class="p-button-secondary" @click.prevent="openConversionDialog(unitConversion)"
                    label="Detail"/>
          </div>
          <UniConversionDetail ref="conversionDialog"/>

          <div class="p-field p-col-12 p-md-1">
            <label for="rate">Rate</label>
            <InputNumber id="rate" v-model="rate" mode="decimal" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="total">Total</label>
            <!-- <input  class="form-control" id="total"  v-model="total" @keypress="isNumber(event)"/> -->

            <InputNumber v-if="$store.state.organisationid != 17" disabled id="minmaxfraction"
                         v-model.lazy="total" :minFractionDigits="2" :maxFracionDigits="4"/>

            <InputNumber v-else id="minmaxfraction" @change="findRate" v-model="total" :minFractionDigits="2"
                         :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button class="p-button-raised p-button-rounded" @click.prevent="addItemToDTOList"
                    :label="!editDto?'Add':'Update'"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button class="p-button-raised p-button-danger" v-if="editDto" @click="itemDTOreset"
                    label="Cancel"/>
          </div>
        </div>
        <!-- // this line is commented for a while by samajdar// -->
        <!-- <div style="display:none;">{{totalAmount}}{{findRate}}{{setRateFromItem}}</div> -->
        <div style="display:none;">{{ totalAmount }}</div>
        <div style="display:none;">{{ setRateFromItem }}</div>
        <div class="p-fluid p-formgrid p-grid" v-if="item.id >0">
          <div class="p-field p-col-12 p-md-2">
            <label for="avl">Cur. Stock:</label>
            <span>{{ item.closingStock }}</span>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="bonus">Bonus:</label>
            <span>{{ item.bonus }}</span>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="expiry">Expiry:</label>
            <span>{{ item.expiryDate }}</span>
          </div>

        </div>
               <div  class="p-fluid p-formgrid p-grid">
            <!-- <div v-if="supplierType == 'Kishan'"> -->
            <!-- </div> -->


 <div class="p-field p-col-12 p-md-2" >
          <a style="font-size: 18px" download="sansthaSales.xlsx"
             href="../../../../static/excelFormat/sansthaSales.xlsx">Download Format</a>
        </div>
        <div class="p-field p-col-12 p-md-2" >
        <input type="file" @change="onFileChangeSanstha" />
        </div>
            </div>
      </form>
      <Dialog header="Do you want to select normal customer or regular customer?" :visible.sync="customerType"
              :style="{width: '75vw', height:'20vw'}" :modal="true" :contentStyle="{'overflow': 'visible'}">
        <template #footer>
          <Button label="No" icon="pi pi-times" @click="closeBasic"
                  class="p-button-raised p-button-danger"/>
          <Button label="Yes" icon="pi pi-check" @click="closeBasic"
                  class="p-button-raised p-button-success" autofocus/>
        </template>
      </Dialog>
      <div class="p-field p-col-12 p-md-12">
        <div class="row">
          <div class="scrollable">
            <table class="table table-bordered ">
              <thead>
              <tr>
                <th scope="col">SN</th>
                <th scope="col">Item Name</th>
                <th scope="col">Customer Name</th>
               <th scope="col">Qty (Ltr)</th>
                        <th scope="col">Fat %</th>
                        <th scope="col">Fat</th>
                        <th scope="col">Snf %</th>
                        <th scope="col">Snf</th>
                         <th scope="col" >Ts %</th>
                        <th scope="col" >Ts</th>
                        <th scope="col">Extra</th>
                <th scope="col">Rate</th>
                <th scope="col">Amount</th>
                <th scope="col">Action</th>
              </tr>
              </thead>
              <tbody v-for="(item,index) in inventoryInOutDetailList " :key="index">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ item.itemMaster.itemNameWithCode }}</td>
                <td>{{ item.supplierName }}</td>
               <td style="text-align:right">{{item.quantity}}</td>
                        <td style="text-align:right">{{item.fatPercentage}}</td>
                        <td style="text-align:right">{{item.fatAmount}}</td>
                        <td style="text-align:right">{{item.snfPercentage}}</td>
                        <td style="text-align:right">{{item.snfAmount}}</td>
                        <td style="text-align:right" >{{item.tsPercentage}}</td>
                        <td style="text-align:right">{{item.tsAmount}}</td>
                        <td style="text-align:right">{{item.rateAdjustment}}</td>
                <td>{{ item.rate }}</td>
                <td>{{ (item.rate * item.quantity).toFixed(4) }}</td>
                <td>
                  <Button class="p-button-raised p-button-success"
                          @click="editItemDTO(item,index)" icon="pi pi-pencil"/>
                  <Button class="p-button-raised p-button-danger" v-if="editDto"
                          @click="removeItemFromDTO(item, index)" icon="pi pi-trash" disabled/>
                  <Button class="p-button-raised p-button-danger" v-else-if="!editDto"
                          @click="removeItemFromDTO(item, index)" icon="pi pi-trash"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <hr>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 15em;">Total:</b>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 16em;">{{ totalQty }}</b>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <b style="margin-left: 38em;">{{ subTotal.toFixed(4) }}</b>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-md-4">
          <label>Narration</label>
          <Textarea rows="6" v-model="narration"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <table style="border: 1px solid #c8c8c8;">
            <thead>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Subtotal</th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ subTotal.toFixed(4) }}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Discount</th>
              <Button v-if="chooseDiscountPer" label="%" @click="chooseDisPercent"/>
              <Button v-if="chooseDiscountAmt" label="RS" @click="chooseDisountAmt"/>
              <td style="border: 1px solid #c8c8c8;padding: 0 0 0;">
                <!-- discountAmt -->
                <InputText v-if="chooseDiscountPer" v-model="discountPer"/>
                <InputText v-if="chooseDiscountAmt" v-model="discountAmt"/>
              </td>
            </tr>
            <tr v-if="chooseDiscountPer">
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Discounted Amt:</th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ discountAmt }}</td>
            </tr>
            <!-- <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">Excise Duty </th>
                <input type="text" class="form-control" v-model="exciseDuty"/>
              <td style="border: 1px solid #c8c8c8;padding: 0px 5em 7px 5em;">{{exciseChargeAmount}}</td>
            </tr> -->
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Taxable</th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ taxable.toFixed(4) }}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Non-taxable</th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ nonTaxable.toFixed(4) }}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Tax</th>
              <th>13%</th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ tax.toFixed(4) }}</td>
            </tr>
            <tr>
              <th style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">Total</th>
              <th></th>
              <td style="border: 1px solid #c8c8c8;padding: 0 5em 7px 5em;">{{ totalBillAmount.toFixed(4) }}</td>
            </tr>
            </thead>
          </table>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <form>
            <label>Extra Expenses:</label>
            <Button class="p-button-raised p-button-rounded" @click.prevent="openBasic" icon="pi pi-plus"/>
            <Dialog header="Extra Expenses" :visible.sync="displayBasic"
                    :style="{width: '60vw'}" :modal="true" :closable=false
                    :contentStyle="{'overflow': 'auto'}">
              <form>
                <div class="p-fluid p-formgrid p-grid p-mt-2">
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpense">Extra Expenses Name</label>
                    <Dropdown
                      v-model="extraExpenses"
                      :options="extraExpensesList"
                      optionLabel="expensesName"
                      :filter="true"
                      placeholder="Select One"
                      id="extraExpense"
                      :showClear="true"
                    />
                  </div>
                  <extraExpensesDialog class="p-mt-5" style="margin-right: -10em;"
                                       v-tooltip.top="'Add Extra Expenses'"/>
                  <div class="p-field p-col-12 p-md-1">
                    <label for="applyVat">Apply Vat</label>
                    <div class="p-field p-col-12 p-md-1">
                      <InputSwitch v-model="applyVat"/>
                    </div>
                  </div>
                  <div class="p-field p-col-12 p-md-2">
                    <label for="extraExpensesAmt">Amount</label>
                    <InputText v-model="extraExpenseAmt" id="extraExpensesAmt"/>
                  </div>

                  <div class="p-field p-col-12 p-md-2">
                    <label for="applyVat">Apply On Bill</label>
                    <div class="p-field p-col-12 p-md-1">
                      <InputSwitch v-model="applyExpensesOnBill"/>
                    </div>
                  </div>
                  <div class="p-field p-col-12 p-md-1 p-mt-5">
                    <Button class="p-button-raised p-button-rounded" @click.prevent="addExtraExpensesToList"
                            :label="!editExtraExpenses?'Add':'Update'"/>
                  </div>
                  <div class="p-field p-col-12 p-md-1 p-mt-5">
                    <Button class="p-button-raised p-button-danger" v-if="editExtraExpenses"
                            @click.prevent="cancelExtraExpenses" label="Cancel"/>
                  </div>
                </div>
              </form>
              <table class="table table-bordered" style="margin-top: 2em;border: 1px solid #c8c8c8;">
                <thead>
                <tr>
                  <th>S.N</th>
                  <th>Expenses Name</th>
                  <th>Apply Vat</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody v-for="(expense,index) in inventoryExtraExpensesList" :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ expense.extraExpense.expensesName }}</td>
                  <td>{{ expense.extraExpense.applyVat ? 'Yes' : 'No' }}</td>
                  <td>{{ expense.extraExpenseAmt }}</td>
                  <td>
                    <Button class="p-button-raised p-button-success"
                            @click.prevent="editExtraExpensesDto(expense,index)" icon="pi pi-pencil"/>
                    <Button class="p-button-raised p-button-danger" v-if="editExtraExpenses"
                            icon="pi pi-trash" @click.prevent="removeExtraExpense(expense, index)" disabled/>
                    <Button icon="pi pi-trash" class="p-button-raised p-button-danger" v-else
                            @click.prevent="removeExtraExpense(expense, index)"/>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="p-fluid p-formgrid p-grid ">
                <div class="p-field p-col-12 p-md-1 p-offset-6">
                  <Button class="p-button-raised p-button-rounded"
                          @click.prevent="closeBasic" label="Save"/>
                </div>
                <div class="p-field p-col-12 p-md-1">
                  <Button @click.prevent="closeBasic"
                          class="p-button-raised p-button-danger" label="Cancel"/>
                </div>
              </div>
            </Dialog>
          </form>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid ">
        <div class="p-field p-col-12 p-md-6"></div>

        <div class="p-field p-col-12 p-md-1">
          <Button icon="pi pi-save" :label="salesInvoice === undefined ? 'Save': 'Update'"
                  class="p-button-raised p-button-success"
                  @click="addSalesInvoice"/>
        </div>
        <div class="p-field p-col-12 p-md-1" v-if="salesInvoice!=undefined">
          <Button class="p-button-raised p-button-danger" @click="goBack()"
                  label="Cancel"/>
        </div>
        <div class="p-field p-col-12 p-md-1" v-if="salesInvoice == undefined">
          <Button icon="pi pi-refresh" label="Reset" class="p-button-raised p-button-warning"
                  @click="reset"/>
        </div>
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised p-button-info" label=" Print" icon="pi pi-print"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <Button icon="pi pi-download" label="Generate PDF" class="p-button-raised p-button-secondary"
                  @click="printBill"/>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import $ from 'jquery'
import InputSwitch from 'primevue/inputswitch'
import Dialog from 'primevue/dialog'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import customerDialog from '../accountDialog/CustomerAccountDialog'
import warehouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import extraExpensesDialog from '../billSundryDialog/billSundrySalesDialog'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import UniConversionDetail from '../commonDialogs/UnitConversionDetail'
import Checkbox from 'primevue/checkbox'
import readXlsxFile from 'read-excel-file'

export default {
  name: 'salesInvoice',
  props: ['salesInvoice'],
  data() {
    return {
      warehouse: '',
      taxTypeList: [
        {name: 'Exclusive', code: 'Exclusive'},
        {name: 'Inclusive', code: 'Inclusive'},
        {name: 'Exempt', code: 'Exempt'}
      ],
      item: '',
      accountMaster: '',
      vendorName: '',
      quantity: 0,
      rate: 0,
      cc: 0,
      foundRateOnItem: false,
      purchaseSalesDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      inventoryExtraExpensesList: [],
      inventoryExtraExpensesDeletedList: [],
      customerAccountList: [],
      purchaseListForSalesList: [],
      latestSalesRateList: [],
      variantDetailslist: [],
      customer: '',
      taxType: '',
      taxable: 0,
      tax: 0,
      unitConversion: '',
      alternateUnit: '',
      nonTaxable: 0,
      vatPercentage: '',
      salesMessage: '',
      // exciseChargeAmount: 0.0,
      // exciseDuty: 0.0,
      editing: false,
      editDto: false,
      billNo: null,
      index: null,
      inventoryOutHeaderId: null,
      loading: false,
      id: null,
      itemSelected: '',
      totalQty: 0,
      total: 0,
      extraExpensesList: null,
      extraExpenseAmt: null,
      applyExpensesOnBill: false,
      displayBasic: false,
      extraExpenses: '',
      applyVat: false,
      editExtraExpenses: false,
      filteredItems: null,
      filterPurchase: null,
      discountPer: 0,
      discountAmt: 0,
      headerId: null,
      printDialog: false,
      isMultiUnit: false,
      savedBill: false,
      englishDateEnabled: true,
      creditLimitAmt: 0,
      customerType: false,
      narration: '',
      setWarehouseData: false,
      orderIdList: [],
      challanIdList: [],
      orderId: null,
      challanId: null,
      loadFromOrder: false,
      loadItemFromPurchase: false,
      loadFromChallan: false,
      loadType: '',
      chooseDiscountPer: true,
      chooseDiscountAmt: false,
      entryType: 'Items',
      purchaseDetailId: '',
      salesRateDetails: false,
      displayVarientsDetails: false,
      enableVarients: false,
      displayVarientsDialog: false,
      perFATPercentage: 0.0,
      perSnfPercentage: 0.0,
      fatPercentage: 0.0,
      fatAmount: 0.0,
      snfPercentage: 0.0,
      tsPercentage: 0.0,
      snfAmount: 0.0,
      perTsPercentage: 0.0,
      tsAmount: 0.0,
      tsRate: 0.0,
      rateAdjustment: 1.0,
      fatRate: 0.0,
      snfRate: 0.0
    }
  },
  computed: {
    unitConversionLists() {
      return this.$store.state.itemgroup.unitConversionLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierCustomerCashList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    },
    // billNo() {
    //   return this.$store.state.sales.maxSalesInvoiceNumber
    // },
    // narration() {
    //   if (this.salesInvoice === undefined) {
    //     return this.salesMessage + ' ' + this.billNo
    //   } else {
    //     return this.salesMessage
    //   }
    // },
    ifCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster.name === 'cash') {
        return true
      }
    },
    ifNotCash() {
      if (this.accountMaster.name === 'Cash' || this.accountMaster === '') {
        return true
      }
    },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = this.quantity * this.rate
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      } else {
        if (isNaN(this.total)) {
          this.total = 0
        }
      }
    },
    findRate() {
      if (isNaN(this.rate)) {
        this.rate = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      if (isNaN(this.quantity)) {
        this.quantity = 0
      }
      if (parseFloat(this.rate) > 0) {
        this.foundRateOnItem = true
      }
      this.rate = (parseFloat(this.rate))
      this.total = (parseFloat(this.total))
      this.quantity = (parseFloat(this.quantity))
      // if (this.foundRateOnItem) {
      // if (this.rate === 0) {
      let rates = 0
      if (this.total > 0 && this.quantity > 0) {
        rates = parseFloat(this.total) / parseFloat(this.quantity)
        this.rate = rates.toFixed(2)
      }
      if (isNaN(rates)) {
        rates = 0
      }
      if (isNaN(this.total)) {
        this.total = 0
      }
      return rates
    },
    setRateFromItem() {
      if (!this.editDto) {
        let rate = 0
        if (this.item !== undefined) {
          this.rate = this.item.salesRate
        } else {
          this.rate = 0
        }
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      let discount = 0
      let discountPerItem = 0
      let totalDiscountPerItem = 0
      this.exciseChargeAmount = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      discount = this.discountAmt
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += parseFloat(this.inventoryInOutDetailList[i].quantity)
        if (this.chooseDiscountPer === true) {
          if (this.discountPer > 100) {
            this.$toast.add({severity: 'error', summary: '', detail: 'Discount must be less than 100 %', life: 10000})
            return
          }
          this.discountAmt = (parseFloat(subTotal) * this.discountPer / 100).toFixed(4)
        }
        if (this.chooseDiscountAmt === true) {
          if (this.discountAmt === '') {
            this.discountAmt = 0.0
          }
        }
        switch (this.taxType) {
          case 'Exclusive':
            if (this.itemSelected.vatable) {
              this.tax = 0
              totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.taxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
              this.tax += parseFloat(this.taxable * 0.13)
              this.addExtraExpenses()
            } else {
              totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
              this.addExtraExpenses()
            }
            break
          case 'Inclusive':
            if (this.itemSelected.vatable) {
              this.tax = 0
              let amtWithoutVat = ((subTotal * 100) / (100 + 13))
              this.taxable = parseFloat(amtWithoutVat)
              this.tax += (parseFloat(subTotal) - parseFloat(amtWithoutVat))
              this.addExtraExpenses()
            } else {
              totalDiscountPerItem = (parseFloat(this.totalQty) * parseFloat(discountPerItem)).toFixed(4)
              this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity) - parseFloat(totalDiscountPerItem))
              this.addExtraExpenses()
            }
            break
          case 'Exempt':
            this.nonTaxable += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
            break
        }
      }
      this.nonTaxable -= discount
      return subTotal
    },
    totalBillAmount() {
      let totalBillAmount = 0.0
      totalBillAmount = parseFloat(this.taxable) + parseFloat(this.tax) + parseFloat(this.nonTaxable)
      return totalBillAmount
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerCashList()
    this.maxSalesBillNo()
    this.itemMasterListByItemTypes()
    this.supplierCustomerList()
    this.extraSalesExpenses()
    if (this.salesInvoice !== undefined) {
      this.editSales()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesInvoice === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
    this.findUnitConversionList()
  },
  methods: {
    async findUnitConversionList() {
      await this.$store.dispatch('loadUnitConversionList')
    },
    setWarehouse() {
      // // debugger
      // console.log()
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouse = this.$store.state.warehouseData
        // // debugger
      } else if (this.warehouseLists.length === 1) {
        this.warehouse = this.warehouseLists[0]
      }
    },
    addExtraExpenses() {
      if (this.inventoryExtraExpensesList.length > 0 & this.applyExpensesOnBill) {
        for (let i = 0; i < this.inventoryExtraExpensesList.length; i++) {
          if (this.inventoryExtraExpensesList[i].applyVat) {
            this.taxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          } else {
            this.nonTaxable += parseFloat(this.inventoryExtraExpensesList[i].extraExpenseAmt)
          }
        }
      }
    },
    async supplierCustomerList() {
      let response = await this.$store.dispatch('loadCustomerSupplierListForDropdown')
      if (response.data.status === 'SUCCESS') {
        this.customerAccountList = response.data.data
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerCashList() {
      await this.$store.dispatch('loadsupplierCustomerAndCashList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypeSales')
    },
    async extraSalesExpenses() {
      let resp = await this.$store.dispatch('extraSalesExpenses')
      this.extraExpensesList = resp.data.data
    },
    async maxSalesBillNo() {
      let response = await this.$store.dispatch('maxSalesInvoiceBillNo')
      if (this.salesInvoice === undefined) {
        this.billNo = response.data.data
        this.salesMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.billNo = this.salesInvoice.billNo
        this.salesMessage = this.salesInvoice.remarks
      }
    },
    editItemDTO(data, index) {
      this.itemDTOreset()
      this.item = data.itemMaster
      this.rate = data.rate
      this.quantity = data.quantity
      this.freeSales = data.freeSales
      this.total = (parseFloat(data.rate) * parseFloat(data.quantity)).toFixed(2)
      this.index = index
      this.editDto = true
      if (parseFloat(this.rate) > 0) {
        this.foundRateOnItem = true
      }
      if (data.id !== undefined) {
        this.id = data.id
      }
      this.focusInput()
    },
    onFileChangeSanstha(event) {
      let xlsxfile = event.target.files ? event.target.files[0] : null
      readXlsxFile(xlsxfile).then((rows) => {
        console.log('rows:', rows)
        // debugger
        rows.forEach(data => {
          // this.findRate(data)
          // this.findFnfAmount(data)
          if (data[1] !== 'Suppliers') {
            let ft = (parseFloat(data[5]) * parseFloat(data[7]))
            this.fatAmount = ft.toFixed(4)
            let fn = (parseFloat(data[6]) * parseFloat(data[8]))
            this.snfAmount = fn.toFixed(4)
            let ts = (parseFloat(data[5]) + parseFloat(data[6])) * parseFloat(data[9])
            this.tsAmount = ts.toFixed(4)
            let rat = (parseFloat(data[5]) * parseFloat(data[7])) + (parseFloat(data[6]) * parseFloat(data[8])) + data[10] + parseFloat(this.tsAmount)
            this.rate = rat.toFixed(4)
            let itemm = {
              itemId: this.item.id,
              itemMaster: this.item,
              quantity: data[4],
              unitName: this.item.unitName,
              id: this.id,
              supplierName: data[1],
              address: data[2],
              contact: data[3],
              fatPercentage: data[5],
              snfPercentage: data[6],
              rateAdjustment: data[10],
              tsPercentage: data[9],
              tsAmount: this.tsAmount,
              rate: this.rate,
              fatAmount: this.fatAmount,
              snfAmount: this.snfAmount
            }
            if (!this.editDTO) {
              this.inventoryInOutDetailList.push({...itemm})
            } else {
              this.inventoryInOutDetailList.splice(this.index, 1, {...itemm})
            }
          }
        })
      })
    },
    amountProvided(data) {
      this.inventoryExtraExpensesList.push({...data})
    },
    addItemToDTOList() {
      if (this.rate === null) {
        this.rate = 0
      }
      if (this.item.bonusItem && this.rate === 0) {
        this.freeSales = true
        this.rate = this.item.salesRate * this.item.ccPercentage / 100
      }
      if (this.entryType === 'Purchase') {
        this.purchaseDetailId = this.item.id
        this.item.id = this.item.itemId
        this.item.bonusItem = this.item.bonusItem
      }
      if (this.$store.getters.modules.includes('5.32')) {
        if (this.item.minimumSalesRate < this.rate) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Sales rate must be grater then minimum sales rate!', life: 10000})
          return
        }
      }
      let item = {
        itemId: this.item.id,
        itemMaster: this.item,
        quantity: this.quantity,
        freeSales: this.freeSales,
        rate: this.rate,
        id: this.id,
        purchaseDetailId: this.purchaseDetailId,
        itemPropertyValuesDTOList: this.variantDetailslist
      }
      if (this.taxType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Sales type!', life: 10000})
        return
      }
      if (this.accountMaster === '' || this.accountMaster === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Sale to!', life: 10000})
        return
      }
      if (this.warehouse === '' || this.warehouse === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.item.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.item === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (!this.item.bonusItem && this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      }
      if (this.item.closingStock < 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Quantity is out of stock!', life: 10000})
      }
      if (!this.editDto) {
        this.inventoryInOutDetailList.push({...item})
      } else {
        this.inventoryInOutDetailList.splice(this.index, 1, {...item})
      }
      this.itemDTOreset()
      this.focusInput()
      this.loadFromItem(this.entryType)
    },
    closeBasicBatchDetails() {
      // this.displayVarientsDetails = false
      this.displayVarientsDialog = false
    },
    addExtraExpensesToList() {
      if (this.extraExpenses === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select Extra expense account!', life: 10000})
        return
      }
      let extraExpense = {
        extraExpense: this.extraExpenses,
        id: this.extraExpenses.id,
        extraExpenseAmt: this.extraExpenseAmt
      }
      if (!this.editExtraExpenses) {
        this.inventoryExtraExpensesList.push({...extraExpense})
      } else {
        this.inventoryExtraExpensesList.splice(this.index, 1, {...extraExpense})
      }
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    editExtraExpensesDto(data, index) {
      this.resetExtraExpenses()
      this.extraExpenses = data.extraExpense
      this.editExtraExpenses = true
      this.index = index
      this.extraExpenseAmt = data.extraExpenseAmt
      if (data.extraExpense.id != null) {
        this.id = data.extraExpense.id
      }
    },
    removeExtraExpense(data, index) {
      if (this.editing) {
        this.inventoryExtraExpensesDeletedList.push({...data})
      }
      this.inventoryExtraExpensesList.splice(index, 1)
    },
    cancelExtraExpenses() {
      this.editExtraExpenses = false
      this.resetExtraExpenses()
    },
    async addSalesInvoice() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      const creditLimitAndDueAmt = parseFloat(this.accountMaster.closingBalance) + parseFloat(this.creditLimitAmt)
      if (creditLimitAndDueAmt < this.totalBillAmount) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Transaction amount exceeds credit limit amount!',
          detail: '',
          life: 10000
        })
      }
      let response = ''
      let salesInvoice = {
        billNo: this.billNo,
        warehouseId: this.warehouse.id,
        accountMasterId: this.accountMaster.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        cashTransactionId: this.customer.id,
        fiscalYearId: this.$store.state.fyId,
        taxType: this.taxType,
        remarks: this.narration,
        billToName: this.vendorName,
        itemLoadFrom: this.entryType,
        // exciseChargeAmount: this.exciseChargeAmount,
        id: this.inventoryOutHeaderId,
        discountPercentage: this.discountPer,
        discount: this.discountAmt,
        subTotalAmount: this.subTotal,
        sumOfQuantity: this.totalQty,
        applyExpensesOnBill: this.applyExpensesOnBill,
        inventoryInOutDetailDeleteList: this.inventoryInOutDetailDeleteList,
        inventoryInOutDetailList: this.inventoryInOutDetailList,
        inventoryExtraExpensesList: this.inventoryExtraExpensesList
      }
      if (salesInvoice.inventoryInOutDetailList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one item!', life: 10000})
        return
      }
      if (this.discountPer > 100) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Discount percentage cannot be greater than 100!',
          life: 10000
        })
        return
      }
      if (this.salesInvoice === undefined || !this.editing) {
        try {
          this.loading = true
          response = await this.$store.dispatch('addSalesDairyInvoice', salesInvoice)
          this.loading = false
        } catch (e) {
          this.loading = false
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Something went wrong!Please contact our support team',
            life: 5000
          })
        }
      } else {
        try {
          this.loading = true
          response = await this.$store.dispatch('updateSalesInvoice', salesInvoice)
          this.loading = false
        } catch (e) {
          this.loading = false
          this.$toast.add({
            severity: 'error',
            summary: '',
            detail: 'Something went wrong!Please contact our support team',
            life: 5000
          })
        }
        let status = {
          message: response.data.message
        }
        this.$router.push({name: 'Sales Invoice Report', params: {status}})
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        await this.maxSalesBillNo()
        // this.focusAfterSave()
        this.itemMasterListByItemTypes()
        this.supplierCustomerList()
        this.supplierCustomerCashList()
        this.savedBill = true
        this.loading = false
        // this.openPrintDialog(response.data.data.id)
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
      this.reset()
    },
    openVarientsDetails() {
      this.displayVarientsDetails = true
    },
    closeVarientsDetails() {
      this.displayVarientsDetails = false
    },
    set_data_warehouse(data) {
      let warehouse = {
        id: data.id,
        name: data.name
      }
      this.warehouse = warehouse
      this.warehouseList()
    },
    set_data_item(data) {
      this.itemMasterListByItemTypes()
      this.items = data
    },
    set_customer_master(data) {
      this.accountMasterId = data
      this.supplierCustomerList()
    },
    editSales() {
      this.editing = !this.editing
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.salesInvoice.purchaseSalesDateNepali
      } else {
        this.purchaseSalesDate = this.salesInvoice.purchaseSalesDate
      }
      // this.purchaseSalesDate = this.salesInvoice.purchaseSalesDate
      // this.referenceNumber = this.salesInvoice.referenceNumber
      // this.exciseDuty = this.salesInvoice.exciseChargeAmount
      this.discountPer = this.salesInvoice.discountPercentage
      this.discountAmt = this.salesInvoice.discount
      this.taxType = this.salesInvoice.vatTypeEnum
      this.warehouse = this.salesInvoice.warehouse
      this.narration = this.salesInvoice.remarks
      this.inventoryOutHeaderId = this.salesInvoice.id
      this.entryType = this.salesInvoice.itemLoadFrom
      this.accountMaster = this.salesInvoice.accountMaster
      if (this.salesInvoice.cashTransactionId !== undefined) {
        this.customer = this.salesInvoice.cashTransactionId
      }
      this.vendorName = this.salesInvoice.billToName
      this.inventoryInOutDetailList = this.salesInvoice.inventoryInOutDetailList
      this.inventoryExtraExpensesList = this.salesInvoice.inventoryExtraExpensesListForReport
      this.variantDetailslist = this.salesInvoice.variantDetailslist
      this.loadFromItem(this.entryType)
      this.chooseDiscountAmt = false
    },
    removeItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
      this.totalBillAmount = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
    },
    itemDTOreset() {
      this.item = ''
      this.rate = 0
      this.quantity = 0
      this.freeSales = false
      this.total = 0
      this.editDto = false
      this.id = null
      this.foundRateOnItem = false
      this.purchaseDetailId = ''
      this.enableVarients = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    closeSalesRatesLatest() {
      this.salesRateDetails = false
    },
    resetExtraExpenses() {
      this.extraExpenses = ''
      this.applyVat = false
      this.extraExpenseAmt = ''
      this.applyExpensesOnBill = false
    },
    reset() {
      this.itemDTOreset()
      this.warehouse = ''
      this.accountMaster = ''
      this.items = ''
      this.discountPer = 0
      this.quantity = 0
      this.freeSales = false
      this.rate = 0
      this.creditLimitAmt = 0
      this.entryType = 'Items'
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.taxType = ''
      this.inventoryInOutDetailList = []
      this.vendorName = ''
      this.inventoryExtraExpensesList = []
      this.enableVarients = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    setNepaliDate() {
      if (this.salesInvoice === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().includes(event.query.toLowerCase()) || item.itemCode.includes(event.query)
          })
        }
      }, 250)
    },
    searchPurchaseItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filterPurchase = [...this.purchaseListForSalesList]
        } else {
          this.filterPurchase = this.purchaseListForSalesList.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    async searchSalesLatestRate() {
      let sales = {
        customerId: this.accountMaster.id,
        itemId: this.item.id
      }
      let res = await this.$store.dispatch('loadLatestSalesRate', sales)
      this.latestSalesRateList = res.data.data
      this.salesRateDetails = true
    },
    async searchItemVariantDetails() {
      if (this.loadItemFromPurchase) {
        let sales = {
          itemId: this.item.id
        }
        let res = await this.$store.dispatch('loadvariantDetailsList', sales)
        this.variantDetailslist = res.data.data
        this.displayVarientsDialog = true
      }
    },
    printBill() {
      let salesInvoice = {
        id: this.headerId,
        type: 'printSalesBill',
        report: 'salesInvoice'
      }
      this.printDialog = false
      this.$store.dispatch('exportToPdf', salesInvoice)
      this.focusAfterSave()
      this.savedBill = false
    },
    openPrintDialog(data) {
      this.printDialog = true
      this.headerId = data
    },
    closePrintDialog() {
      this.printDialog = false
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.salesInvoice.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    },
    async getCreditLimitAmount() {
      let resp = await this.$store.dispatch('getCreditLimitAmount', this.accountMaster.id)
      this.creditLimitAmt = resp.data.data
      if (this.accountMaster.isCashAccount) {
        this.customerType = true
      }
    },
    async loadFrom(data) {
      if (data === 'order') {
        this.loadFromOrder = true
        this.loadFromChallan = false
        let orderIds = await this.$store.dispatch('loadSalesOrderIdList')
        this.orderIdList = orderIds.data.data
        // // debugger
      }
      if (data === 'challan') {
        this.loadFromChallan = true
        this.loadFromOrder = false
        let challanIds = await this.$store.dispatch('loadSalesChallanIdList')
        this.challanIdList = challanIds.data.data
      }
    },
    async loadFromItem(data) {
      this.loading = true
      if (data === 'Items') {
        this.loadItemFromPurchase = false
        // let orderIds = await this.$store.dispatch('loadPurchaseListForSales')
        // this.orderIdList = orderIds.data.data
        // // debugger
      }
      if (data === 'Purchase') {
        let dat = {
          warehouse: this.warehouse.id
        }
        let rep = await this.$store.dispatch('loadPurchaseListForSales', dat)
        this.purchaseListForSalesList = rep.data.data
        this.loadItemFromPurchase = true
        this.enableVarients = true
      }
      this.loading = false
    },
    // async loadPurchaseFromWarehouse(id) {
    //   if (this.entryType === 'Purchase') {
    //       let dat = {
    //         warehouse: id
    //     }
    //     let rep = await this.$store.dispatch('loadPurchaseListForSales', dat)
    //     this.purchaseListForSalesList = rep.data.data
    //   }
    // },
    async loadSalesOrderDataWithOrderNo(orderNo) {
      let response = await this.$store.dispatch('loadDataWithSalesOrderId', orderNo)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseDate
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          this.accountMaster = data.accountMaster
          this.warehouse = data.warehouse
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
          // this.narration = data.remarks
          // this.referenceNumber = data.referenceNumber
        })
      }
    },
    async loadSalesOrderDataWithChallanNo(challan) {
      let response = await this.$store.dispatch('loadDataWithSalesChallanNo', challan)
      if (response.data.data.length > 0) {
        response.data.data.forEach(data => {
          if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
            this.purchaseSalesDate = data.purchaseSalesDateNepali
          } else {
            this.purchaseSalesDate = data.purchaseDate
          }
          this.accountMaster = data.accountMaster
          this.warehouse = data.warehouse
          this.inventoryInOutDetailList = data.inventoryInOutDetailList
          // this.narration = data.remarks
          // this.referenceNumber = data.referenceNumber
        })
      }
    },
    chooseDisPercent() {
      this.chooseDiscountPer = false
      this.chooseDiscountAmt = true
      this.discountPer = 0
    },
    chooseDisountAmt() {
      this.chooseDiscountAmt = false
      this.chooseDiscountPer = true
      this.discountAmt = 0
    },
    openConversionDialog(unitConver) {
      let unitConversion = {
        uniConversion: unitConver,
        isPurchaseSales: 'sales'
      }
      this.$refs.conversionDialog.openDialog(unitConversion)
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputSwitch,
    Dialog,
    AutoComplete,
    InputNumber,
    InputMask,
    customerDialog,
    warehouseDialog,
    itemDialog,
    extraExpensesDialog,
    Button,
    Textarea,
    UniConversionDetail,
    Checkbox,
    readXlsxFile
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// salesInvoiceDairy.vue?06267a16